export default alpineDebugger = (Alpine) => {
  Alpine.data("mrdebugger", () => ({
    allData: {},

    init() {
      // wait for all the x-data's to load
      window.addEventListener("load", () => {
        document.querySelectorAll('[x-data]').forEach(el => {
          if (el == this.$el) {
            return;
          }
          if (el._x_dataStack && el._x_dataStack.length > 0) {
            let key = el.tagName.toLowerCase() + '_' + Math.random().toString(36).substr(2, 9);
            if (el.id != '') {
              key = el.id;
            }
            const data = this.getCircularSafeData(el._x_dataStack[0]);
            if (Object.keys(data).length > 0) {
              this.allData[key] = data;
            }
          }
        });
      });
    },

    getCircularSafeData(obj) {
      const seen = new WeakSet();
      return JSON.parse(JSON.stringify(obj, (key, val) => {
        if (val != null && typeof val === 'object') {
          if (seen.has(val)) {
            return '[Circular]';
          }
          seen.add(val);
        }
        return val;
      }));
    }
  }));
}
